import * as constants from './constants';
import * as actions from './actions';
import * as types from './types';
import reducer from './reducer';
import * as selectors from './selectors';
import * as components from './components';
import * as epics from './epics';

export { types as UI };
export default { reducer, actions, constants, selectors, components, epics };
